import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ViewUserCoachDetailWrapper = styled.div`
  margin-top: 10px;
  ${responsive.MOBILE`
    margin-top: 0px;
  `}
  .MuiAccordionSummary-expandIconWrapper {
    display: none;
  }
  .accordion-container {
    padding: 0 16px 0 16px;
  }
  .MuiAccordionDetails-root {
    padding-bottom: 30px;
    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }
  .coach-details-container {
    padding-bottom: 30px;
    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }

  .chip-day {
    .MuiButtonBase-root {
      text-transform: capitalize;
    }
  }
`;
